import {getEnvironment} from "../../../lib/get-environment";

const PAYRIX_CONFIG_DEV = {
    base: 'https://test-portal.payrix.com',
    client_id: '6200fb617effc293d6a1a89a9af60c47771cb810f9347708c3b969a773ae737c',
    signup_uri: 'https://test-portal.payrix.com/signup/OutlawPracticeSandbox',
    bankDisclosureId: 'g15fad80b630242',
    termsId: 'g15fecdf635fd81'
};

const PAYRIX_CONFIG_DEMO = {
    base: 'https://test-portal.payrix.com',
    client_id: 'd9ac5917a2b198927357a9e5ed679a41bb5d48d74be3a0ea5255be0c1c25217c',
    signup_uri: 'https://test-portal.payrix.com/signup/OutlawPracticeSandbox',
    bankDisclosureId: 'g15fad80b630242',
    termsId: 'g15fecdf635fd81'
};

const PAYRIX_CONFIG_TEST = {
    base: 'https://test-portal.payrix.com',
    client_id: '2ecd16153c974a038b542431b3621765f5d96e89e927eb73ab93f5e3467b5c41',
    signup_uri: 'https://test-portal.payrix.com/signup/OutlawPracticeSandbox',
    bankDisclosureId: 'g15fad80b630242',
    termsId: 'g15fecdf635fd81'
};

const PAYRIX_CONFIG_PROD = {
    base: 'https://mypayments.outlawpractice.com',
    client_id: '3502fb028cce304121f8f010b7e6455974d2bc4aa5a41c5069fc6563a3cc2de8',
    signup_uri: 'https://mypayments.outlawpractice.com/signup/OutlawPractice',
    bankDisclosureId: 'g15fdb7f154b2c6',
    termsId: 'g1602542276a163'
};

let PAYRIX_CONFIG: PayrixConfig = null;

switch(getEnvironment()) {
    case 'P':
        PAYRIX_CONFIG = PAYRIX_CONFIG_PROD;
        break;
    case 'B':
        PAYRIX_CONFIG = PAYRIX_CONFIG_PROD;
        break;
    case 'DM':
        PAYRIX_CONFIG = PAYRIX_CONFIG_DEMO;
        break;
    case 'T':
        PAYRIX_CONFIG = PAYRIX_CONFIG_TEST;
        break;
    default:
        PAYRIX_CONFIG = PAYRIX_CONFIG_DEV;
}

export type PayrixConfig = null | {
    base: string,
    client_id: string,
    signup_uri: string,
    bankDisclosureId: string,
    termsId: string
};

export default PAYRIX_CONFIG;
